export const theme = {
  // Colors
  red: '#ff0000',
  coral: '#FF4B44',
  blue: '#194beb',
  blueOpacity: 'rgba(0, 119, 200, 0.6)',
  blue2: '#0767a8',
  blue2Opacity: 'rgba(7, 103, 168, 0.6)',
  turquoise: '#00D4D6',
  light: '#F6F6F6',
  light2: 'rgba(235, 235, 236, 1)',
  light2Opacity: 'rgba(235, 235, 236, 0.6)',
  mainGrey: '#EBEBED',
  mainGreyOpacity: 'rgba(235, 235, 237, 0.9)',
  mainGreyMidOpacity: 'rgba(235, 235, 237, 0.6)',
  gray: '#d5d7d7',
  gray2: '#a9aeb4',
  gray3: '#333538',
  gray4: '#ebebec',
  gray5: '#605E6F',
  dark: '#25282a',
  darkWithOpacity: 'rgba(37, 40, 42, 0.9)',
  darkWithLowOpacity: 'rgba(37, 40, 42, 0.1)',
  dark2: '#1d282e',
  dark3: '#666869',
  dark4: '#000D16',
  dark4MidOpacity: 'rgba(0,13,22, 0.6)',
  dark4Opacity: 'rgba(0,13,22, 0.9)',
  black: '#131313',
  dark5: '#302F45',
  dark5Opacity: 'rgba(48, 47, 69,0.9)',
  headerBlack: '#00001B',
  yellow: '#f6be00',
  orange: '#ff6a39',
  white: '#ffffff',
  green: '#00B187',
  whiteWithOpacity: 'rgba(255,255,255,0.9)',
  whiteWithMidOpacity: 'rgba(255,255,255,0.6)',
  blueWithOpacity: 'rgba(0,119,200,0.9)',
  blue2WithOpacity: 'rgba(7, 103, 168, 0.9)',
  lightWithOpacity: 'rgba(235,235,236,0.9)',
  grayWithOpacity: 'rgba(213,215,215,0.9)',
  whiteWithLowOpacity: 'rgba(255,255,255,0.1)',
  purple: '#9B5CFF',

  success: '#70A370',
  danger: '#BA5555',

  dangerLight: '#C17170',

  // Fonts
  primaryFont: 'LALIGATextRegular',
  primaryFontMedium: 'LALIGATextRegular',
  primaryFontLight: 'LALIGATextLight',
  primaryFontBold: 'LALIGAText',
  primaryFontHead: 'LALIGAHeadlineStd',
  primaryFontHeadBold: 'LALIGAHeadlineStdBold',

  // Type scales
  h1: 37,
  h2: 29,
  h3: 23,
  h4: 19,
  h5: 15,
  headerTitle: 32,
  title: 24,
  button: 16,
  paragraph: 12,
  paragraphBig: 16,
  paragraphMedium: 13,
  paragraphSmall: 11,
  label: 10,
  shieldExtraBig: 120,
  shieldBig: 60,
  shieldMedium: 40,
  shieldSmall: 20,

  // Breakpoints
  breakpoints: {
    xs: 420,
    sm: 767,
    md: 900,
    lg: 1024,
    xl: 1330,
  },
};
